<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
        <svg-icon src="./assets/images/icons/close.svg"></svg-icon>
    </button>
</div>
<div class="modal-body">
    <h4 class="font-weight-semibold mb-3 mb-md-4">Move To</h4>
    <form [formGroup]="myForm" (ngSubmit)="onSubmit()" enctype="multipart/form-data">
        <div formArrayName="newUsersGroups">
            <div class="d-flex align-items-center column-gap-3 mb-3 mb-md-4">
                <div class="form-group floating_form_field mb-0 w-100"
                    *ngFor="let item of newUsersGroups().controls; let i=index" [formGroupName]="i">
                    <ng-select
                        [items]="mainGroups"
                        [multiple]="true"
                        bindLabel="groupName"
                        [selectableGroup]="false"
                        [closeOnSelect]="false"
                        bindValue="groupId"
                        [virtualScroll]="false"
                        (change)="selectGroupData($event)"
                        (clear)="clearSelectedData()"
                        [clearable]="true"
                        formControlName="groupid"
                        (open)="onCSGSelectOpen()"
                        class="custom"
                    >
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <div class="custom-control custom-checkbox">
                                <input id="item-{{index}}" type="checkbox" class="custom-control-input" name="item-{{index}}" [ngModel]="item$.selected" [ngModelOptions]="{standalone: true}">
                                <label class="custom-control-label cursor-pointer">{{item.groupName}}</label>
                            </div>
                        </ng-template>
                    </ng-select>
                    <label [ngClass]="CSGSelectFocused && 'focused'">Select Customer Service Group</label>
                    <div class="d-flex justify-content-between">
                        <div *ngIf="newUsersGroups().controls[i].get('groupid').invalid && newUsersGroups().controls[i].get('groupid').touched"
                            class="small text-danger">
                            <div *ngIf="newUsersGroups().controls[i].get('groupid').errors?.required">
                                Group Name is required
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
            class="d-flex align-items-center justify-content-end column-gap-3">
            <button class="btn btn-clear w-50" type="button" (click)="modal.dismiss()">Cancel</button>
            <button class="btn btn-primary w-50" type="submit">Submit</button>
        </div>
    </form>
</div>